import Vue from 'vue'
import router from './router'
import store from './store'
import Buefy from 'buefy'
import VueCookies from 'vue-cookies'
import VueMeta from 'vue-meta'
import VueApexCharts from 'vue-apexcharts'
import VueTheMask from 'vue-the-mask'
import App from './App.vue'

import i18n from '@/plugins/i18n'
import resize from '@/plugins/resize'
import alert from '@/plugins/alert'
import dayjs from '@/plugins/day'
import validate from '@/plugins/validate'

import mixins from '@/mixins'
import globalMixin from '@/mixins/globalMixin.js'

Vue.config.productionTip = false

Vue.use(Buefy)
Vue.use(VueCookies)
Vue.use(VueMeta)
Vue.use(VueApexCharts)
Vue.use(VueTheMask)

Vue.use(resize)
Vue.use(alert)
Vue.use(dayjs)
Vue.use(validate)

Vue.mixin(mixins)
Vue.mixin(globalMixin)

import '@/styles/app.scss'

new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
}).$mount('#app')
